'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _utils = require('./utils');

var reduxMap = ['methods', 'mapState', 'mapDispatch', 'connectState'];

exports.default = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function (Component) {
    if (options.connect !== false && (0, _utils.includesOne)(Object.keys(Component), reduxMap)) {
      return (0, _reactRedux.connect)(Component['mapState'] || Component['connectState'], Component['mapDispatch'], Component['mergeProps'], options.connect)(Component);
    }

    return Component;
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/abyss-react/lib/applyRedux.js
// module id = 528
// module chunks = 0